<template>
  <PuSkeletonTheme :duration="0.1" :color="skeletonColor" :highlight="skeletonHighlight">
    <div class="flex items-center">
      <vs-avatar
        :src="`https://portal-cdn.rapid.education/profile-pictures/${user.profile_picture}.jpeg`"
        class="flex-shrink-0 mr-2"
        size="30px"
        @click="$router.push(url)"
      />
      <router-link v-if="user.full_name" :to="url" class="text-inherit hover:text-primary" vi @click.stop.prevent>
        {{ this.user.full_name }}
      </router-link>
      <PuSkeleton v-else class="" style="width: 250px; height: 100%"></PuSkeleton>
    </div>
  </PuSkeletonTheme>
</template>

<script>
export default {
  data () {
    return {
      user: {
        full_name: null,
        profile_picture: 'default'
      }
    }
  },
  computed: {
    url () {
      return `/a/users/${this.params.value}`
    },
    authorId () {
      return this.params.data.author
    },
    skeletonColor () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(224, 224, 224)'
      if (theme === 'dusk') return 'rgb(5, 0, 53, 1)'
      if (theme === 'dark') return 'rgb(22, 23, 25)'
    },
    skeletonHighlight () {
      const theme = this.$store.state.theme
      if (theme === 'light') return 'rgb(248, 248, 248)'
      if (theme === 'dusk') return 'rgb(27 25 53)'
      if (theme === 'dark') return 'rgb(94 94 94 / 73%)'
    }
  },
  created () {
    this.$httpCached
      .get(`users/${this.params.value}?cc=course_subscription_table_user`, {
        ttl: 15
      })
      .then((response) => {
        if (response.data.data) {
          this.user = response.data.data
          this.user.full_name = `${this.user.first_name} ${this.user.last_name}`
          this.user.profile_picture = response.data.data.profile_picture !== null ? response.data.data.profile_picture : 'default'
        }
      })
      .catch((exception) => {
        let error = 'An unknown error occurred loading customer details'
        if (exception.response) {
          error = exception.response.data.error.description
        }

        return this.$vs.notify({
          title: 'Failed to author',
          text: error,
          color: 'danger',
          position: 'top-right'
        })
      })
  }
}
</script>
